<template>
  <v-card
    flat
    tile
  >
    <v-card-title class="px-0">{{ metadata.title }}</v-card-title>
    <v-card-text class="px-0">
      <tiptap-vuetify
        :extensions="extensions"
        v-bind:value="value"
        v-on:input="$emit('input', $event)"
        min-height="150px"
        :disabled="disabled"
      ></tiptap-vuetify>
    </v-card-text>
  </v-card>
</template>

<script>
  import { TiptapVuetify, Heading, Bold, Italic, Strike, Underline, Paragraph, BulletList, OrderedList, ListItem, Link, Blockquote, HardBreak, HorizontalRule, Image } from 'tiptap-vuetify'

  export default {
    name: "MetaFieldLongText",

    components: {
      TiptapVuetify
    },

    props: [
      'value',
      'metadata',
      'disabled'
    ],

    data: () => ({
      // WYSIWYG extensions to use, these must be included on import.
      extensions: [
        Underline,
        Strike,
        Italic,
        Bold,
        ListItem,
        Blockquote,
        BulletList,
        OrderedList,
        [Heading, {
          options: {
            levels: [2, 3, 4]
          }
        }],
        Link,
        HorizontalRule,
        Paragraph,
        HardBreak,
        Image
      ],
    }),

    methods: {
    }
  }
</script>

<style>
.description img {
  width: 100%;
}
</style>
